import React, { useState, useCallback } from 'react';
import ImageViewer from 'react-simple-image-viewer';
import Img1 from './img/trip/2022.jpg';
import Img2 from './img/trip/2022_0.jpg';
import Img3 from './img/trip/2022_1.jpg';
import Img4 from './img/trip/2022_2.jpg';
import Img5 from './img/trip/mad1.jpg';
import Img7 from './img/trip/mad2.jpg';
import Img9 from './img/trip/comgh1.jpg';
import Img10 from './img/trip/give1.jpg';
import Img11 from './img/trip/give2.jpg';
import Img12 from './img/trip/give3.jpg';
import Img13 from './img/trip/kenya.jpg';
import Img14 from './img/trip/kenya1.jpg';
import Img15 from './img/trip/ethio1.jpg';
import Img16 from './img/trip/ethio2.jpg';
import Img17 from './img/trip/ethio3.jpg';
import Img18 from './img/trip/ethio4.jpg';
import Img19 from './img/FB_IMG_1689787670548.jpg';
import Img20 from './img/FB_IMG_1689787673712.jpg';
import Img21 from './img/FB_IMG_1689787676879.jpg';
import Com1 from './img/trip/iji1.jpg';
import Com2 from './img/trip/iji2.jpg';
import Com3 from './img/trip/iji3.jpg';
import Com4 from './img/trip/comgh1.jpg';
import Com5 from './img/trip/give1.jpg';
import Tan2 from './img/trip/com2.jpeg';
import Tan3 from './img/trip/com3.jpeg';
import Tan4 from './img/trip/com4.jpeg';
import Tan5 from './img/trip/com5.jpeg';
import Tan6 from './img/trip/com6.jpeg';
import Tan7 from './img/trip/com7.jpeg';

import uganda1 from './img/trip/uganda1.jpeg';
import uganda2 from './img/trip/uganda2.jpeg';
import uganda3 from './img/trip/uganda3.jpeg';
import evan1 from './img/trip/evan1.jpeg';
import evan2 from './img/trip/evan2.jpeg';
import evan3 from './img/trip/evan3.jpeg';
import Carousel_ from 'react-grid-carousel';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { colors } from './sharedStyles';

const useStyles = makeStyles((theme) => ({
  galleryContainer: {
    padding: '20px 0',
  },
  galleryItem: {
    position: 'relative',
    borderRadius: 12,
    overflow: 'hidden',
    boxShadow: '0 4px 20px rgba(97, 218, 251, 0.15)',
    transition: 'all 0.3s ease',
    cursor: 'pointer',
    '&:hover': {
      transform: 'translateY(-5px)',
      boxShadow: '0 12px 40px rgba(97, 218, 251, 0.25)',
    },
  },
  galleryImage: {
    width: '100%',
    height: 250,
    objectFit: 'cover',
    borderRadius: 12,
  },
  imageCaption: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    background: 'linear-gradient(transparent, rgba(0,0,0,0.8))',
    color: 'white',
    padding: '20px 15px 15px',
    fontSize: '0.9rem',
    fontWeight: 600,
    textAlign: 'center',
  },
  carouselContainer: {
    '& .react-grid-carousel__item': {
      padding: '10px',
    },
  },
  imageViewerOverlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.9)',
  },
  imageViewerCloseButton: {
    color: 'white',
    fontSize: '2rem',
    cursor: 'pointer',
    position: 'absolute',
    top: '20px',
    right: '20px',
    zIndex: 1000,
    background: 'rgba(0,0,0,0.5)',
    borderRadius: '50%',
    width: 50,
    height: 50,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'none',
    '&:hover': {
      background: 'rgba(0,0,0,0.8)',
    },
  },
  imageViewerNavButton: {
    color: 'white',
    fontSize: '1.5rem',
    cursor: 'pointer',
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 1000,
    background: 'rgba(0,0,0,0.5)',
    borderRadius: '50%',
    width: 40,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'none',
    '&:hover': {
      background: 'rgba(0,0,0,0.8)',
    },
  },
  imageViewerPrevButton: {
    left: '20px',
  },
  imageViewerNextButton: {
    right: '20px',
  },
}));

function App() {
  const classes = useStyles();
  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  
  const images = [
    [uganda1, 'Community Outreach in Uganda 2025'],
    [uganda2, 'Community Outreach in Uganda 2025'],
    [uganda3, 'Community Outreach in Uganda 2025'],
    [evan3, 'Evangelism In Tanzania (2024)'],
    [evan2, 'Evangelism In Tanzania (2024)'],
    [evan1, 'Evangelism In Tanzania (2024)'],
    [Tan7, 'Community Outreach In Tanzania (2024)'],
    [Tan2, 'Community Outreach In Tanzania (2024)'],
    [Tan3, 'Community Outreach In Tanzania (2024)'],
    [Tan4, 'Community Outreach In Tanzania (2024)'],
    [Tan5, 'Community Outreach In Tanzania (2024)'],
    [Tan6, 'Community Outreach In Tanzania (2024)'],
  

    [Com5, 'Community Outreach In Ghana (2022)'],
    [Com4, 'Community Outreach In Ghana (2022)'],
    [Com3, 'Community Outreach In Fiji'],
    [Com2, 'Community Outreach In Fiji'],
    [Com1, 'Community Outreach In Fiji'],
    [Img19, 'Community Outreach In Tanzania'],
    [Img20, 'Community Outreach In Tanzania'],
    [Img1, 'Evangelism In Madagascar'],
    [Img2, 'Evangelism In Madagascar'],
    [Img3, 'Evangelism In Madagascar'],
    [Img4, 'Evangelism In Madagascar'],
    [Img5, 'Community Outreach In Madagascar'],
    [Img7, 'Community Outreach In Madagascar'],
    [Img11, 'Community Outreach In India'],
    [Img12, 'Community Outreach In India'],
    [Img13, 'Community Outreach In Kenya'],
    [Img14, 'Community Outreach In Kenya'],
    [Img15, 'Evangelism in Ethiopia'],
    [Img16, 'Evangelism in Ethiopia'],
    [Img17, 'Evangelism in Ethiopia'],
    [Img18, 'Evangelism in Ethiopia']
  ];
  
  const images_ = images.map(img => img[0]);

  const openImageViewer = useCallback((index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  const goToPrevious = () => {
    setCurrentImage((prevIndex) => 
      prevIndex === 0 ? images_.length - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentImage((prevIndex) => 
      prevIndex === images_.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Escape') {
      closeImageViewer();
    } else if (e.key === 'ArrowLeft') {
      goToPrevious();
    } else if (e.key === 'ArrowRight') {
      goToNext();
    }
  }, []);

  React.useEffect(() => {
    if (isViewerOpen) {
      document.addEventListener('keydown', handleKeyDown);
      return () => document.removeEventListener('keydown', handleKeyDown);
    }
  }, [isViewerOpen, handleKeyDown]);

  const Caroo = () => {
    return (
      <div className={classes.galleryContainer}>
        <Carousel_ cols={4} rows={4} gap={20} loop className={classes.carouselContainer}>
          {images.map((list, index) => (
            <Carousel_.Item key={index}>
              <div 
                className={classes.galleryItem}
                onClick={() => openImageViewer(index)}
              >
                <img 
                  src={list[0]} 
                  alt={list[1]}
                  className={classes.galleryImage}
                />
                <div className={classes.imageCaption}>
                  <Typography variant="body2" style={{fontWeight: 600}}>
                    {list[1]}
                  </Typography>
                </div>
              </div>
        </Carousel_.Item>
          ))}
    </Carousel_>
        </div>
    );
  };

  return (
    <div>
      <Caroo />
      
      {isViewerOpen && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.95)',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <button 
            className={classes.imageViewerCloseButton}
            onClick={closeImageViewer}
            aria-label="Close"
          >
            ×
          </button>
          
          <button 
            className={`${classes.imageViewerNavButton} ${classes.imageViewerPrevButton}`}
            onClick={goToPrevious}
            aria-label="Previous"
          >
            ‹
          </button>
          
          <button 
            className={`${classes.imageViewerNavButton} ${classes.imageViewerNextButton}`}
            onClick={goToNext}
            aria-label="Next"
          >
            ›
          </button>
          
          <div style={{
            position: 'relative',
            maxWidth: '90vw',
            maxHeight: '90vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <img 
              src={images_[currentImage]} 
              alt={images[currentImage][1]}
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain',
                borderRadius: 8,
              }}
            />
            
            <div style={{
              position: 'absolute',
              bottom: '-60px',
              left: 0,
              right: 0,
              textAlign: 'center',
              color: 'white',
              fontSize: '1.1rem',
              fontWeight: 600,
            }}>
              {images[currentImage][1]}
            </div>
            
            <div style={{
              position: 'absolute',
              top: '-40px',
              left: 0,
              right: 0,
              textAlign: 'center',
              color: 'white',
              fontSize: '0.9rem',
            }}>
              {currentImage + 1} of {images_.length}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;